import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChartWaterfallAxis: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chart-waterfall-axis"><path d="M3.75 3.75V20.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.75 13.25V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.75 16.25V11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 10.25V5.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 14.25V9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChartWaterfallAxis;
